<template>
    <div class="mb-20">
        <label
            class="font-bold block mb-5"
        >{{ label }}</label>

        <div class="tags--items flex flex-wrap gap-10">
            <button
                v-for="option in displayOptions"
                :key="option.value"
                :aria-selected="option.selected"
                :class="{ 'bg-indigo-400 text-white': option.selected, 'bg-gray-100': !option.selected }"
                class="rounded p-5 border-gray-200 hover:border-indigo-400 border-1 cursor-pointer flex items-center"
                type="button"
                @click="toggleOption(option)"
            >
                {{ option.label }}
                <span
                    v-if="multiple"
                    class="ml-10 bg-gray-300 rounded-full w-20 h-20 inline-block text-center leading-[1] text-gray-700"
                >
                    <template v-if="option.selected">&times;</template>
                    <template v-else>+</template>
                </span>
            </button>
        </div>

        <p v-for="error in errors"
           v-if="errors.length > 0"
           class="text-red-500">
            {{ error }}
        </p>

        <p
            v-if="helpText"
            class="text-gray-600">
            {{ helpText }}
        </p>
    </div>
</template>

<script>
export default {
    name: "FormSelect",
    props: {
        id: String,
        label: String,
        required: Boolean,
        modelValue: Array | String | Number,
        disabled: Boolean,
        multiple: Boolean,
        helpText: String,
        step: String | Number,
        options: Array,
        optionLabel: {
            type: String,
            default: "name"
        },
        optionValue: {
            type: String,
            default: "id"
        },
        errors: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    emits: ['update:modelValue'],
    methods: {
        toggleOption(option) {
            if (this.multiple) {
                if (option.selected) {
                    const index = this.modelValue.indexOf(option.value);

                    this.$emit('update:modelValue', [
                        ...this.modelValue.slice(0, index),
                        ...this.modelValue.slice(index + 1)
                    ]);
                } else {
                    this.$emit('update:modelValue', [...this.modelValue, option.value]);
                }
            } else {
                this.$emit('update:modelValue', option.selected ? null : option.value);
            }
        }
    },
    computed: {
        idOrLabel() {
            return this.id ?? this.label;
        },
        displayOptions() {
            return this.options.map(option => {
                const opt = {
                    label: option[this.optionLabel],
                    value: option[this.optionValue],
                };

                if (this.multiple) {
                    opt.selected = this.modelValue.some(selectedOption => selectedOption === option[this.optionValue]);
                } else {
                    opt.selected = this.modelValue === option[this.optionValue];
                }

                return opt;
            });
        }
    }
}
</script>
